import { getStorage, getBlob, ref } from 'firebase/storage'
import jszip from 'jszip'

const downloader = {
  async downloadFromLocation(location, name) {
    let fileRef = ref(getStorage(), location)
    await this.downloadfromStorage(fileRef, name)
  },

  async downloadfromStorage(fileRef, name) {
    const blob = await getBlob(fileRef)
    await this.downloadBlob(blob, name)
  },

  async downloadBlob(blob, name) {
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.style.display = 'none'
    link.setAttribute('href', url)
    link.setAttribute('download', name)
    document.body.appendChild(link)
    link.click()
    link.remove()
    // Libère la mémoire une fois le téléchargement lancé
    setTimeout(() => URL.revokeObjectURL(url), 60 * 1000)
  },

  downloadUncodedUri(uri, name) {
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(uri)
    link.download = name
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  },

  async downloadFolder(files, name) {
    const zip = new jszip()

    await Promise.all(files.map(async file => {
      const blob = await getBlob(file.ref)
      zip.file(file.path, blob)
    }))

    const zipData = await zip.generateAsync({ type: 'blob' })
    this.downloadBlob(zipData, name)
  }
}

export default downloader
